<template>
  <ul class="p-the-header-navi-on-general__navi--usermenu">
    <li class="p-the-header-navi-on-general__navi__item">
      <NaviItemLinkForSpOnGeneral :url="urls.mypage" label="マイページ">
        <template #icon>
          <IconBase :width="24" :height="24" view-box="0 0 24 24">
            <IconHumanWithOutline />
          </IconBase>
        </template>
      </NaviItemLinkForSpOnGeneral>
    </li>

    <li class="p-the-header-navi-on-general__navi__item">
      <NaviItemLinkForSpOnGeneral
        :url="urls.point_confirmation"
        label="ポイント確認"
      >
        <template #icon>
          <IconPointDefault
            :icon-size="24"
            :bg-color="iconColor"
            icon-color="#ffffff"
            :border-color="iconColor"
          />
        </template>
      </NaviItemLinkForSpOnGeneral>
    </li>

    <li
      v-if="thanksFunctionEnabled && !isGroupBudget"
      class="p-the-header-navi-on-general__navi__item"
    >
      <NaviItemLinkForSpOnGeneral
        :url="urls.thanks_point"
        :label="thanksPointName + 'メッセージ'"
        :notification-count="thanksPointUnread"
      >
        <template #icon>
          <IconBase
            :width="24"
            :height="24"
            view-box="0 0 24 24"
            :icon-color="iconColor"
          >
            <IconThanksMessage />
          </IconBase>
        </template>
      </NaviItemLinkForSpOnGeneral>
    </li>

    <li class="p-the-header-navi-on-general__navi__item">
      <NaviItemLinkForSpOnGeneral
        :url="urls.whats_new"
        label="お知らせ"
        :notification-count="whatsNewUnread"
      >
        <template #icon>
          <IconBase
            :width="24"
            :height="24"
            view-box="0 0 24 24"
            :icon-color="iconColor"
          >
            <IconNotification />
          </IconBase>
        </template>
      </NaviItemLinkForSpOnGeneral>
    </li>
    <li class="p-the-header-navi-on-general__navi__item">
      <NaviItemLinkForSpOnGeneral :url="urls.orders" label="申込履歴">
        <template #icon>
          <IconBase
            :width="24"
            :height="24"
            view-box="0 0 24 24"
            :icon-color="iconColor"
          >
            <IconOrderHistory />
          </IconBase>
        </template>
      </NaviItemLinkForSpOnGeneral>
    </li>
    <li class="p-the-header-navi-on-general__navi__item">
      <NaviItemLinkForSpOnGeneral :url="urls.visit" label="閲覧履歴">
        <template #icon>
          <IconBase
            :width="24"
            :height="24"
            view-box="0 0 24 24"
            :icon-color="iconColor"
          >
            <IconHistoryLog />
          </IconBase>
        </template>
      </NaviItemLinkForSpOnGeneral>
    </li>
    <li class="p-the-header-navi-on-general__navi__item">
      <NaviItemLinkForSpOnGeneral :url="urls.favorites" label="お気に入り">
        <template #icon>
          <IconBase
            :width="24"
            :height="24"
            view-box="0 0 24 24"
            :icon-color="iconColor"
          >
            <IconHeart />
          </IconBase>
        </template>
      </NaviItemLinkForSpOnGeneral>
    </li>
    <li class="p-the-header-navi-on-general__navi__item">
      <NaviItemLinkForSpOnGeneral
        v-if="!showMailSettings && !isGroupBudget"
        :url="urls.mail_settings"
        label="メール受信設定"
      >
        <template #icon>
          <IconBase
            :width="24"
            :height="24"
            view-box="0 0 24 24"
            icon-color="transparent"
          >
            <IconMail />
          </IconBase>
        </template>
      </NaviItemLinkForSpOnGeneral>
    </li>
  </ul>
</template>

<script lang="ts">
import IconBase from "@/common/components/atoms/IconBase.vue";
import IconHumanWithOutline from "@/common/components/icons/IconHumanWithOutline.vue";
import IconThanksMessage from "@/common/components/icons/IconThanksMessage.vue";
import IconNotification from "@/common/components/icons/IconNotification.vue";
import IconPointDefault from "@/common/components/icons/IconPointDefault.vue";
import PointNotation from "@/common/components/atoms/PointNotation.vue";
import NaviItemLinkForSpOnGeneral from "@/common/components/organisms/header/general/NaviItemLinkForSpOnGeneral.vue";
import IconHeart from "@/common/components/icons/IconHeart.vue";
import IconOrderHistory from "@/common/components/icons/IconOrderHistory.vue";
import IconHistoryLog from "@/common/components/icons/IconHistoryLog.vue";
import IconMail from "@/common/components/icons/IconMail.vue";
import { Options, Vue } from "vue-class-component";
import CONST_DATA from "@/general/mixins/const/constData";
import commons from "@/common/store/modules/commons";
import { getThanksPointName } from "@/common/assets/js/utils/pointName";
import auth from "@/general/store/modules/auth";
@Options({
  name: "TheHeaderNaviOfUserMenu",
  props: {
    point: { type: Number, required: true },
    unit: { type: Object, required: true },
    iconColor: { type: String, required: true },
    whatsNewUnreadCount: { type: Number, required: false, default: 0 },
    thanksPointUnreadCount: { type: Number, required: false, default: 0 }
  },
  components: {
    IconBase,
    IconHumanWithOutline,
    IconThanksMessage,
    IconNotification,
    IconPointDefault,
    IconHeart,
    IconOrderHistory,
    IconHistoryLog,
    IconMail,
    PointNotation,
    NaviItemLinkForSpOnGeneral
  },
  filters: {
    addComma(value: any) {
      const number = Number(value);
      if (Number.isNaN(number)) {
        return value;
      }
      return number.toLocaleString();
    }
  }
})
export default class TheHeaderNaviOfUserMenu extends Vue {
  point!: number;
  unit!: Record<string, any>;
  iconColor!: string;
  whatsNewUnreadCount!: number;
  thanksPointUnreadCount!: number;

  get thanksPointUnread() {
    const total = this.thanksPointUnreadCount;
    return total >= CONST_DATA.LIMITS.UNREAD_COUNT_DISPLAY_LIMIT ? "..." : total;
  }

  get whatsNewUnread() {
    const total = this.whatsNewUnreadCount;
    return total >= CONST_DATA.LIMITS.UNREAD_COUNT_DISPLAY_LIMIT ? "..." : total;
  }

  get thanksFunctionEnabled() {
    return commons.thanksFunctionEnabled;
  }

  get urls() {
    return {
      home: CONST_DATA.SITE_MAP.TOP_PAGE,
      point_confirmation: CONST_DATA.SITE_MAP.POINT_CONFIRMATION,
      thanks_point: CONST_DATA.SITE_MAP.THANKS_POINT,
      whats_new: CONST_DATA.SITE_MAP.WHATS_NEW,
      favorites: process.env.VUE_APP_MYPAGE + "/favorites/",
      orders: process.env.VUE_APP_MYPAGE + "/orders",
      visit: process.env.VUE_APP_MYPAGE + "/visits/",
      mail_settings: CONST_DATA.SITE_MAP.MAIL_DELIVERY_SETTINGS,
      mypage: process.env.VUE_APP_MYPAGE
    };
  }

  get showMailSettings() {
    const user = auth.user;
    if (!user) return false;

    return (
      !user.approval_result_notification_mail &&
      !user.point_expiry_notification_enabled &&
      !user.point_balance_notification_enabled &&
      !user.point_receipt_notification_enabled &&
      !user.mail_magazine_enabled
    );
  }

  get isGroupBudget() {
    return commons?.userInfo.groupBudgetMode;
  }

  get thanksPointName() {
    return getThanksPointName(CONST_DATA.POINT_NAME.THANKS_POINT_DEFAULT_NAME2);
  }
}
</script>

<style lang="scss" scoped>
.p-the-header-navi-on-general__navi {
  width: 100%;

  &--service {
    margin-top: rem(32);
  }

  &--contact {
    margin-top: rem(20);
    padding-top: rem(20);
    position: relative;

    &::before {
      content: "";
      display: block;
      width: calc(100% - 2.2857142857142856rem);
      height: px(2);
      margin: auto;
      left: 0;
      right: 0;
      top: 0;
      position: absolute;
      background-color: $common-gray500;
    }
  }

  &--child {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    left: 0;
    top: 0;
    transform: translateX(100%);
  }

  &__item {
    width: 100%;
  }

  &__point {
    margin: 0 0 rem(8) rem(24 + 8);
    padding: 0 rem(16);

    &__text {
      font-size: rem(10);
    }
  }
}
</style>
